module.exports = __webpack_public_path__ + "static/media/web_1-15.0fc84018.jpg";